import { useTheme } from '../../hooks/useTheme';
import { Theme } from '../../state/theme';
import { SettingsDrawer, TabMap } from './SettingsDrawer';

export function SettingsDrawerWrapper({ tabMap }: { tabMap: TabMap }) {
  const { theme } = useTheme();

  return <SettingsDrawer tabMap={tabMap} isDarkTheme={theme === Theme.DARK} />;
}
